import Admin from "src/types/Admin.type";
import _isEmpty from "lodash/isEmpty";

const hasPendingInvites = (user?: Admin): boolean => !_isEmpty(user?.InviteRequest);

export default hasPendingInvites;